import { useCallback, useMemo } from 'react'

import { ampli } from '../../../ampli'

export type Theme = 'light' | 'dark' | 'auto'
export type ThemeChangedSource = 'preferences' | 'header'

interface ThemeChangedProps {
  new_theme: Theme
  previous_theme: Theme
  theme_changed_source: ThemeChangedSource
}

const canTrack = (): boolean => {
  return typeof window !== 'undefined' && ampli.isLoaded
}

export const useThemeTracker = () => {
  const themeChanged = useCallback((props: ThemeChangedProps) => {
    if (!canTrack()) return
    ampli.themeChanged(props)
  }, [])

  return useMemo(() => ({ themeChanged }), [themeChanged])
}
